var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"ma-1",class:[
    _vm.validated? 'inspection-card':'',
    _vm.open ? 'active' : '',
    !_vm.validated? 'normal-cursor':''
  ],attrs:{"width":"114","height":"103","max-height":"103","max-width":"114","ripple":_vm.ripple},on:{"click":_vm.openCard}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }